import * as _ from 'lodash';
import { change, DataShape, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import * as formUtils from 'login-utils/formUtils';
import * as onboardingForm from 'login-utils/onboardingForm';

import JourneyChooser, { baseInputs, getTimelineChooserConfig } from './JourneyChooser';

const FORM_ERROR_ID = 'JourneyChooser-formError';

const mapStateToProps = (state, _props) => {
  const journeyOption = onboardingForm.getTimelineValue(state);
  return {
    phoneNumber: onboardingForm.getValueFromKey(state, 'phoneNumber'),
    loanType: onboardingForm.getLoanType(state),
    selectedTimelineValue: _.get(
      getTimelineChooserConfig(journeyOption),
      'value',
      null,
    ) as onboardingForm.TimelineValue | null,
  };
};

const mapDispatchToProps = dispatch => ({
  setPhoneNumber: phoneNumber => {
    dispatch(change(onboardingForm.FORM_NAME, onboardingForm.FIELDS.phoneNumber, phoneNumber));
  },
  selectTimelineValue: value => {
    const formValuesToSet = onboardingForm.translateTimelineValueToFormProps(value);
    _.forEach(formValuesToSet, (formValue, key) => dispatch(change(onboardingForm.FORM_NAME, key, formValue)));
  },
});

const ConnectedJourneyChooser = connect(
  mapStateToProps,
  mapDispatchToProps,
)(JourneyChooser);

const FormConnectedJourneyChooser = reduxForm<JourneyChooser.OwnFormProps, {}, ReduxState>({
  ...onboardingForm.FORM_CONFIG,
  validate: (values: DataShape) => {
    return formUtils.validate(baseInputs, values);
  },
  onSubmitFail: syncErrors => formUtils.focusOnSubmitFail(syncErrors, FORM_ERROR_ID),
})(ConnectedJourneyChooser);

export default FormConnectedJourneyChooser;
